import { css } from '@emotion/react'
import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { Spacer, SharedModal, Loading } from './'
import { ModalActions, ModalConfirmButton, ModalCancelButton } from './ModalActions'

const DeleteText = styled.div`
  color: #4a606a;
  font-size: 24px;
  line-height: 33px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

class DeleteModal extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    title: PropTypes.string,
    handleConfirmation: PropTypes.func,
    error: PropTypes.bool,
    loading: PropTypes.bool,
  }

  render() {
    const {
      handleConfirmation,
      isModalOpen,
      toggleModal,
      title = 'Delete This Information',
      error,
      loading,
    } = this.props

    return (
      <SharedModal isModalOpen={isModalOpen} title={title} toggleModal={toggleModal}>
        <DeleteText>
          <p>Are you sure?</p>
          <Spacer space='6px' />
          <p> This action can't be undone.</p>
        </DeleteText>
        {error && (
          <div
            css={css`
              color: #e31e27;
              font-size: 14px;
              line-height: 1.5;
              text-align: center;
              padding: 0.25rem 0 0.75rem 0;
            `}>
            Something went wrong, please try again later.
          </div>
        )}
        {loading ? (
          <Loading />
        ) : (
          <ModalActions>
            <ModalCancelButton type='button' onClick={toggleModal}>
              Cancel
            </ModalCancelButton>
            <ModalConfirmButton type='button' onClick={handleConfirmation}>
              Yes
            </ModalConfirmButton>
          </ModalActions>
        )}
      </SharedModal>
    )
  }
}

export default DeleteModal
